import React, { useState, useEffect } from 'react'

import { Button, Card, CardContent, Container, Grid, IconButton, Snackbar, Tooltip, Typography } from '@material-ui/core'
import { Assignment } from '@material-ui/icons'
import { useStyles } from '../styles'
import { useDatabase } from '../DatabaseContext'
import { useAdDatabase } from '../AdDatabaseContext'
import { db } from '../firebase';


function EndMessageCard() {

  const classes = useStyles()
  const { curUser, endSessionTime } = useAdDatabase()

  const [loading, setLoading] = useState(false)
  const [finished, setFinished] = useState(false)
  const [error, setError] = useState('')
  const [code, setCode] = useState(0)
  const [open, setOpen] = useState(false)
  const [numPurchases, setNumPurchases] = useState(0);




  const handleClick = () => {
    setLoading(true)
    setError('')
    endSessionTime().then(uniqueCode => {
      setCode(uniqueCode)
      setFinished(true)
      setLoading(false)
    }).catch(err => {
      setError('Some error occurred. Please try again.')
      setLoading(false)
    })
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${code}`)
    setOpen(true)
  }

  const handleSnackbarClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    const numPurchasesRef = db.collection('users').doc(curUser.prolificId);
    numPurchasesRef.get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();
          const numPurchases = data.numPurchases || 0;
          setNumPurchases(numPurchases);
        } else {
          console.error('User document not found');
        }
      })
      .catch((error) => {
        console.error('Error fetching user document:', error);
      });
  }, [curUser.prolificId]);


  return (
    <div className='EndMessageCard'>
      <Container maxWidth='md'>
        <Card className={classes.cardLoginSignup}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='body1' align='center'>
                  {finished ?
                    `And it\'s done. Since you made ${numPurchases} purchase(s), your total payment is $${4 - 0.1*numPurchases}. Please copy the code below and complete the rest of the Qualtrics survey. Remember you also need to insert this code to the Prolific interface to receive payment.` :
                    'Thank you. Please click the button below to finish the survey and generate your unique code. You\'ll need it to complete the Qualtrics questionnaire and receive payment from Prolific.'
                  }
                </Typography>
              </Grid>
              {finished ?
                <Grid container item xs={12} justifyContent='center' alignItems='center'>
                  <Grid item xs='auto'>
                    <Typography variant='h3' align='center'>
                      Your code: C13HIAXU
                    </Typography>
                  </Grid>
                  <Grid item xs='auto'>
                    <Tooltip title='Copy code to clipboard'>
                      <IconButton onClick={copyToClipboard}>
                        <Assignment />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid> :
                <Grid container item xs={12} justifyContent='center'>
                  <Button variant='contained' color='primary' onClick={handleClick} disabled={loading}>
                    Generate code
                  </Button>
                </Grid>
              }
              {error &&
                <Grid container item xs={12} justifyContent='center'>
                  <Typography variant='body2' color='error'>
                    {error}
                  </Typography>
                </Grid>
              }
            </Grid>
          </CardContent>
        </Card>
      </Container>

      <Snackbar
        open={open}
        message='Copied'
        onClose={handleSnackbarClose}
        autoHideDuration={5000}
      />
    </div>
  )
}

export default EndMessageCard
